import {
  require_jquery
} from "./chunk-IL4DE2EU.js";
import "./chunk-624QZG55.js";
export default require_jquery();
//# sourceMappingURL=jquery.js.map
